import { V as VaAccordion } from "../../components/va-accordion/index.js";
import { V as VaAffix } from "../../components/va-affix/index.js";
import { V as VaAlert } from "../../components/va-alert/index.js";
import { V as VaAppBar } from "../../components/va-app-bar/index.js";
import { V as VaAspectRatio } from "../../components/va-aspect-ratio/index.js";
import { V as VaAvatar } from "../../components/va-avatar/index.js";
import { V as VaAvatarGroup } from "../../components/va-avatar-group/index.js";
import { V as VaBacktop } from "../../components/va-backtop/index.js";
import { V as VaBadge } from "../../components/va-badge/index.js";
import { a as VaBreadcrumbs, V as VaBreadcrumbsItem } from "../../components/va-breadcrumbs/index.js";
import { V as VaButton } from "../../components/va-button/index.js";
import { V as VaButtonDropdown } from "../../components/va-button-dropdown/index.js";
import { V as VaButtonGroup } from "../../components/va-button-group/index.js";
import { V as VaButtonToggle } from "../../components/va-button-toggle/index.js";
import { d as VaCard, b as VaCardActions, c as VaCardBlock, V as VaCardContent, a as VaCardTitle } from "../../components/va-card/index.js";
import { V as VaCarousel } from "../../components/va-carousel/index.js";
import { V as VaCheckbox } from "../../components/va-checkbox/index.js";
import { V as VaChip } from "../../components/va-chip/index.js";
import { V as VaCollapse } from "../../components/va-collapse/index.js";
import { V as VaColorIndicator } from "../../components/va-color-indicator/index.js";
import { V as VaColorInput } from "../../components/va-color-input/index.js";
import { V as VaColorPalette } from "../../components/va-color-palette/index.js";
import { _ as _sfc_main } from "../../components/va-config/VaConfig.vue_vue_type_script_setup_true_lang.js";
import { V as VaContent } from "../../components/va-content/index.js";
import { V as VaCounter } from "../../components/va-counter/index.js";
import { V as VaDataTable } from "../../components/va-data-table/index.js";
import { V as VaDateInput } from "../../components/va-date-input/index.js";
import { V as VaDatePicker } from "../../components/va-date-picker/index.js";
import { V as VaDivider } from "../../components/va-divider/index.js";
import { V as VaDropdown } from "../../components/va-dropdown/index.js";
import { V as VaDropdownContent } from "../../components/va-dropdown/components/VaDropdownContent/index.js";
import { V as VaFallback } from "../../components/va-fallback/index.js";
import { V as VaFileUpload } from "../../components/va-file-upload/index.js";
import { V as VaForm } from "../../components/va-form/index.js";
import { V as VaHover } from "../../components/va-hover/index.js";
import { V as VaIcon } from "../../components/va-icon/index.js";
import { V as VaImage } from "../../components/va-image/index.js";
import { V as VaInfiniteScroll } from "../../components/va-infinite-scroll/index.js";
import { V as VaInnerLoading } from "../../components/va-inner-loading/index.js";
import { V as VaInput } from "../../components/va-input/index.js";
import { V as VaLayout } from "../../components/va-layout/index.js";
import { V as VaInputWrapper } from "../../components/va-input-wrapper/index.js";
import { b as VaList, V as VaListItem, d as VaListItemLabel, a as VaListItemSection, c as VaListLabel, e as VaListSeparator } from "../../components/va-list/index.js";
import { V as VaMessageList } from "../../components/va-message-list/VaMessageList.js";
import { V as VaModal } from "../../components/va-modal/VaModal.js";
import { V as VaNavbar, a as VaNavbarItem } from "../../components/va-navbar/index.js";
import { V as VaOptionList } from "../../components/va-option-list/index.js";
import { V as VaPagination } from "../../components/va-pagination/index.js";
import { V as VaParallax } from "../../components/va-parallax/index.js";
import { V as VaPopover } from "../../components/va-popover/index.js";
import { V as VaProgressBar } from "../../components/va-progress-bar/index.js";
import { V as VaProgressCircle } from "../../components/va-progress-circle/index.js";
import { V as VaRadio } from "../../components/va-radio/index.js";
import { V as VaRating } from "../../components/va-rating/index.js";
import { V as VaSelect } from "../../components/va-select/index.js";
import { _ as _sfc_main$1 } from "../../components/va-separator/VaSeparator.vue_vue_type_script_setup_true_lang.js";
import { V as VaSkeleton, a as VaSkeletonGroup } from "../../components/va-skeleton/index.js";
import { V as VaSidebar } from "../../components/va-sidebar/index.js";
import { V as VaSidebarItem, a as VaSidebarItemContent, b as VaSidebarItemTitle } from "../../components/va-sidebar/VaSidebarItem/index.js";
import { V as VaSlider } from "../../components/va-slider/index.js";
import { _ as _sfc_main$2 } from "../../components/va-spacer/VaSpacer.vue_vue_type_script_setup_true_lang.js";
import { V as VaSplit } from "../../components/va-split/index.js";
import { V as VaSwitch } from "../../components/va-switch/index.js";
import { V as VaTabs } from "../../components/va-tabs/index.js";
import { V as VaTab } from "../../components/va-tabs/components/VaTab/index.js";
import { V as VaStepper } from "../../components/va-stepper/index.js";
import { V as VaTimeInput } from "../../components/va-time-input/index.js";
import { V as VaTimeline } from "../../components/va-timeline/index.js";
import { V as VaTimelineItem } from "../../components/va-timeline/VaTimelineItem/index.js";
import { V as VaTimePicker } from "../../components/va-time-picker/index.js";
import { V as VaToast } from "../../components/va-toast/toast.js";
import { V as VaTreeView } from "../../components/va-tree-view/index.js";
import { V as VaScrollContainer } from "../../components/va-scroll-container/index.js";
import { V as VaViewer } from "../../components/va-viewer/index.js";
import { V as VaValue } from "../../components/va-value/index.js";
import { V as VaVirtualScroller } from "../../components/va-virtual-scroller/index.js";
import { V as VaTextarea } from "../../components/va-textarea/index.js";
import { V as VaMenu } from "../../components/va-menu/va-menu.js";
import { b as VaMenuGroup, a as VaMenuItem, V as VaMenuList } from "../../components/va-menu-list/index.js";
import { V as VaFormField } from "../../components/va-form-field/index.js";
const vuesticComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VaAccordion,
  VaAffix,
  VaAlert,
  VaAppBar,
  VaAspectRatio,
  VaAvatar,
  VaAvatarGroup,
  VaBacktop,
  VaBadge,
  VaBreadcrumbs,
  VaBreadcrumbsItem,
  VaButton,
  VaButtonDropdown,
  VaButtonGroup,
  VaButtonToggle,
  VaCard,
  VaCardActions,
  VaCardBlock,
  VaCardContent,
  VaCardTitle,
  VaCarousel,
  VaCheckbox,
  VaChip,
  VaCollapse,
  VaColorIndicator,
  VaColorInput,
  VaColorPalette,
  VaConfig: _sfc_main,
  VaContent,
  VaCounter,
  VaDataTable,
  VaDateInput,
  VaDatePicker,
  VaDivider,
  VaDropdown,
  VaDropdownContent,
  VaFallback,
  VaFileUpload,
  VaForm,
  VaFormField,
  VaHover,
  VaIcon,
  VaImage,
  VaInfiniteScroll,
  VaInnerLoading,
  VaInput,
  VaInputWrapper,
  VaLayout,
  VaList,
  VaListItem,
  VaListItemLabel,
  VaListItemSection,
  VaListLabel,
  VaListSeparator,
  VaMenu,
  VaMenuGroup,
  VaMenuItem,
  VaMenuList,
  VaMessageList,
  VaModal,
  VaNavbar,
  VaNavbarItem,
  VaOptionList,
  VaPagination,
  VaParallax,
  VaPopover,
  VaProgressBar,
  VaProgressCircle,
  VaRadio,
  VaRating,
  VaScrollContainer,
  VaSelect,
  VaSeparator: _sfc_main$1,
  VaSidebar,
  VaSidebarItem,
  VaSidebarItemContent,
  VaSidebarItemTitle,
  VaSkeleton,
  VaSkeletonGroup,
  VaSlider,
  VaSpacer: _sfc_main$2,
  VaSplit,
  VaStepper,
  VaSwitch,
  VaTab,
  VaTabs,
  VaTextarea,
  VaTimeInput,
  VaTimePicker,
  VaTimeline,
  VaTimelineItem,
  VaToast,
  VaTreeView,
  VaValue,
  VaViewer,
  VaVirtualScroller
}, Symbol.toStringTag, { value: "Module" }));
export {
  vuesticComponents as v
};
//# sourceMappingURL=components.js.map
